import { Component } from '@angular/core';

@Component({
  selector: 'cms-footer',
  template: '<fin-footer />',
  standalone: false,
})
export class CmsFooterComponent {
  constructor() {
    /* noop */
  }
}
